'use client';
import "@/assets/css/products.css";
import HeaderProduct from "@/Components/HeaderProduct/HeaderProduct";
import GetDetailsPart from "@/product/[id]/Components/GetDetailsPart";
import Gallery from "@/product/[id]/Components/Gallery/Gallery";
import { useProduct } from "./product-context";
import StructuredData from "@/Components/StructuredData/StructuredData";
import { buildBreadcrumbSchema, buildProductSchema } from "@/lib/structured-data";

function isKitProduct(product) {
    return String(product?.kind || "").trim().toUpperCase() === "KIT";
}

function isBundleIncludesDetail(detail) {
    const text = String(detail?.text || "");
    return /<h[1-6][^>]*>\s*Bundle includes\s*<\/h[1-6]>/i.test(text)
        || /\bBundle includes\b/i.test(text);
}

export default function ProductPage() {
    const { product } = useProduct();

    if (!product) {
        return <p className="text-danger my-5">Failed to load product details.</p>;
    }

    const visibleDetails = Array.isArray(product.details)
        ? product.details.filter((detail) => isKitProduct(product) || !isBundleIncludesDetail(detail))
        : [];

    return (
        <div>
            <StructuredData
                data={[
                    buildBreadcrumbSchema([
                        { name: "Home", path: "/" },
                        { name: product.name, path: `/product/${product.alt_id}` },
                    ]),
                    buildProductSchema(product),
                ]}
            />
            <HeaderProduct product={product} />

            <div className="ux-container">
                <h1 className="my-4">{product.name}</h1>
                <div className="row mb-5">
                    <div className={`${product.media && product.media.length ? "col-12 col-md-4 mb-3" : "d-none"}`}>
                        <div className="sticky">
                            <h4 className="spotlight-product-heading">{product.name}</h4>
                            <hr className="heading-content-divider"/>
                            <Gallery media={product.media} productName={product.name} productSlug={product.alt_id} />
                        </div>
                    </div>
                    <div className={`testing-focus ${product.media && product.media.length ? "col-12 col-md-8" : "col-12"}`}>
                        <GetDetailsPart
                            determinant="DESCRIPTION"
                            details={visibleDetails}
                            characterAmount="0"
                            showHeading={true}
                        />
                    </div>
                </div>
                {visibleDetails.slice(2).map(d => //slice(2) is for skipping Summary and Description
                    <div key={d.id} className="bm-5 mt-5">
                        <div key={d.id} dangerouslySetInnerHTML={{__html: d.text}} />
                        <div className="mb-5"/>
                    </div>
                )}
            </div>
        </div>
    );
}
